$(document).ready(function () {

	$('.product__buttons .button').on("click", function () {
      $('.wrapformPopupShow').show();
  });
  $('.wrapformPopupClose').on("click", function () {
    $('.wrapformPopupShow').hide();
  });

	$('.offerCommunicateForm .closed').on("click", function () {
		$('.formErrors__item.success').hide()
	});

	AOS.init({
			disable: 'mobile',
		});

	$('.filtrProduct__producent').select2({
		placeholder: 'Producent',
		allowClear: true
	});
	$('.filtrProduct__format').select2({
		placeholder: 'Format',
		allowClear: true
	});
	$('.filtrProduct__color').select2({
		placeholder: 'Kolor',
		allowClear: true
	});
	$('.filtrProduct__destiny').select2({
			placeholder: 'Przeznaczenie',
			allowClear: true
	});

	$('.search__icon').click(function(){
			$('.search__form').slideToggle();
	});

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 300) {
      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });


	//language switcher
	$('.js-top__language').on('click',function(){
			$(this).toggleClass('top__language--open');
			return false;
	});

		//language switcher
	$('.js-top__language a:not(.active)').on('click',function(){
				$(this).addClass('active').siblings().removeClass('active');
				window.location.href = $(this).attr('href');
		});

		$(".slider .owl-carousel").owlCarousel({
	 items:1,
	 // animateIn: 'lightSpeedIn',
  	// animateIn: 'pulse',
	 margin:0,
	 stagePadding:0,
	 smartSpeed:450,
	 autoplay:true,
	 nav:true,
	 navText : ["",""],
	 loop:true,
	 dots:true,
	 autoplayTimeout:7000,
	 autoplayHoverPause:true,
	 onChange: callback,
 });
 function callback(event) {
		// $('.sliderItem .sliderImage').hide();
		// $('.sliderItem .sliderImage').addClass('fadeInUp animated');

		clearTimeout(myVar);
		var myVar = setTimeout(function() {
			// $('.owl-item.active').find('.sliderItem .sliderImage').show();
		}, 500);
	}

	let offerPage = 0;
	let filteredPosts = [];
	let perPage = 9;

	function showNextOfferPage(){
		if(offerPage==0)
			$(".offerList").html();
		for(let j=offerPage*perPage;j<(offerPage+1)*perPage;j++){
			if(typeof filteredPosts[j] !== "undefined"){
				var html = '<a href="'+filteredPosts[j].url+'" class="offerItem">';
				if(typeof filteredPosts[j].img !== "undefined")
					html+= '<img src="'+filteredPosts[j].img+'" alt="'+filteredPosts[j].title+'"/>';
				html+= '<div class="offerItem__prodContent"><span class="offerItem__prodContent__name">'+filteredPosts[j].title+'</span><span class="offerItem__prodContent__desc">'+filteredPosts[j].desc+'</span></div></a>';
				$(".offerList").append(html);
			}
		}
		offerPage++;
		if(filteredPosts.length<=offerPage*perPage){
			$('[data-offer-shownextpage]').hide();
		}else{
			$('[data-offer-shownextpage]').show();
		}
	}

	$('[data-offer-shownextpage]').bind('click',showNextOfferPage);

	$('[data-offer-filter]').on("select2:selecting select2:clearing", function(e) {
		setTimeout(function(){
	    var options = [
	      $("[data-offer-filter]:eq(0) option:selected").val(),
	      $("[data-offer-filter]:eq(1) option:selected").val(),
	      $("[data-offer-filter]:eq(2) option:selected").val(),
				$("[data-offer-filter]:eq(3) option:selected").val()
	    ];

	    $(".offerList a").fadeOut().promise().done(function(){
	      if(options[0]=="" && options[1]=="" && options[2]=="" && options[3]==""){
					if(typeof offerPosts !== "undefined"){
						filteredPosts = offerPosts;
						offerPage = 0;
						showNextOfferPage();
					}else
	        	$(".offerList a").fadeIn();
	      }else{
	        $("[data-offer-filterempty]").css({'display':'none'});
	        var links = $(".offerList a"), regexp, counter = 0,validcounter;
					if(typeof offerPosts !== "undefined"){
						filteredPosts = [];
						for(let i=0;i<offerPosts.length;i++){
							counter = validcounter = 0;
							for(var j=0;j<options.length;j++){
								if(options[j]!=""){
									counter++;
									regexp = new RegExp(","+options[j]+",");
									if(regexp.test(offerPosts[i].dictionary)){
										validcounter++;
									}
								}
							}
							if(counter == validcounter){
								filteredPosts.push(offerPosts[i]);
								console.log(offerPosts[i]);
							}
						}
						offerPage = 0;
						showNextOfferPage();
					}else{
		        for(var i=0;i<links.length;i++){
		          counter = validcounter = 0;
		          for(var j=0;j<options.length;j++){
		            if(options[j]!=""){
		              counter++;
		              regexp = new RegExp(","+options[j]+",");
		              if(regexp.test(links.eq(i).attr('data-dictionary'))){
		                validcounter++;
									}
		            }
		          }
		          if(counter == validcounter)
		            links.eq(i).fadeIn();
		        }

		        if($(".offerList a:visible").length==0)
		          $("[data-offer-filterempty]").css({'display':'block'});
					}
	      }
	    });
		},100);
  });

	if(typeof offerPosts !== "undefined"){
		filteredPosts = offerPosts;
		showNextOfferPage();
	}

 //Manufacturers
  var letterDisplay = $("#letterDisplay");
  var boxes = $(".box");
  var letterContainer = $("#letterContainer");
  var letterContainerInner = $(".letterContainer__inner");
  var formPopupOverlay = $(".formPopup-overlay");
  var formPopup = $(".formPopup");
  var closeBtn = $(".formPopup__close");

  function filterBoxes(letter) {
    boxes.each(function() {
      var box = $(this);
      var boxLetter = box.attr("class").split(" ").find(function(className) {
        return className.startsWith("box--");
      }).replace("box--", "").toLowerCase(); ;
      if (letter === "all" || boxLetter === letter) {
        box.css("display", "inline-block");
      } else {
        box.css("display", "none");
      }
    });
    if (letter === "all") {
      letterDisplay.text("");
    } else {
      letterDisplay.text(letter.toUpperCase());
    }
  }

  letterContainer.on("click", ".letterLink", function(event) {
    event.preventDefault();
    var selectedLetter = $(this).attr("data-letter");
    filterBoxes(selectedLetter);
    $(".letterLink").removeClass("active");
    $(this).addClass("active");
  });

  boxes.on("click", function() {
    formPopupOverlay.show();
    formPopup.show();
    $(document).on('click', '[id^="manufacturer"]', function() {
      var manufacturerName = $(this).find('.box__caption').text();
	  if(manufacturerName){
      	$('input[name="manufacturerName"]').val(manufacturerName);
	  }
    });
    $("body").css("overflow", "hidden");
  });

  closeBtn.on("click", function() {
    formPopupOverlay.hide();
    formPopup.hide();
    $("body").css("overflow", "auto");
  });

  formPopupOverlay.on("click", function() {
    formPopupOverlay.hide();
    formPopup.hide();
    $("body").css("overflow", "auto");
  });

  for (var i = 97; i <= 120; i++) {
    var letter = String.fromCharCode(i);
    var letterLink = $("<span>").addClass("letterLink").attr("data-letter", letter).text(letter);
    letterContainerInner.append(letterLink);
  }

  filterBoxes("all");
});
